/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 7/13/14
 * Time: 4:13 PM
 * To change this template use File | Settings | File Templates.
 *
 * Responsible for actions on the categories table page, update the models, and sync between the data and the views
 * All the changes are made on the base categories collection and not on the merged categories + dependencies collection.
 * Flow:
 *  1) Change on categories collection (this controller)
 *  2) Change on the merged categories + dependencies collection (data controller)
 *  3) Can be viewed on the selectable collection (Selectable decorator)
 *  4) Change on the organized collection (Organize decorator)
 *  5) UI is re-rendered (CategoriesGridView)
 *
 *
 */
define(function (require) {
    'use strict';

    var LE = require("app");
    var Media = require("media");
    var Page = require("ui.components/page/Page");
    var ErrorCodes = require("codeTables/errorCodes.json");
    var NoData = require("ui.components/no-data/NoData");

    var CategoriesTableLayout = require("manager-views/categories/CategoriesTableLayout");
    var CategoriesGridView = require("manager-views/categories/CategoriesGridView");
    var CategoriesGridModel = require("manager-models/categories/CategoriesGridModel");
    var CategoriesComparators = require("manager-comparators/CategoriesComparators");

    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var OrganizeCollectionDecorator = require ("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");
    var DependencyService = require("src/components/dependency-service/controllers/DependencyService");
    var CategoryModel = require("manager-models/CategoryModel");
    var CategoriesCollection = require("manager-collections/CategoriesCollection");


    var API_DELETE = "delete";
    var API_ORDER = "order";
    var API_SAVE = "save";
    var ORDER_COMPARATOR = "order";
    var ASC_ORDERBY = "asc";
    var DEFAULT_COMPARATOR = ORDER_COMPARATOR;
    var DEFAULT_ORDERBY = ASC_ORDERBY;

    var ADDITIONAL_PAGE_CLASS_NAME = "categories-page";

    var CategoriesTableController = {};


    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        CategoriesTableController = Marionette.Controller.extend({
            categoriesCollection: null,

            initialize: function(options) {
                LEManager.logger.info ("initializing","CategoriesTableController:initialize");
                this.vent = Media.channel("categories").vent;
                this.reqres = Media.channel("categories").reqres;
                this.currentComparator = DEFAULT_COMPARATOR;
                this.currentOrderBy = DEFAULT_ORDERBY;
                this.hasEditPrivileges = LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.EDIT_AC_CATEGORIES);
                this._prepareCollections();

                this._initPageComponent();
                this._bindEvents();

                this.categoriesGridModel = new CategoriesGridModel();
            },

            /**
             * Responsible for decorate the collection.
             * Define a variable that points to the base categories collection
             * Decorates the merged collection to be Selectable and Organize
             * @private
             */
            _prepareCollections: function() {
                LEManager.logger.debug ("prepare collection: selectable and organize","CategoriesTableController:_prepareCollections");
                this.categoriesCollection = LEManager.getDataManager().getCategoriesCollection();
                this.categoriesWithDependenciesCollection = LEManager.getDataManager().getCategoriesWithDependenciesCollection();
                this.categoriesWithDependenciesCollection =  SelectableCollectionDecorator.decorate(this.categoriesWithDependenciesCollection);
                this.categoriesWithDependenciesCollection =  OrganizeCollectionDecorator.decorate(this.categoriesWithDependenciesCollection, {comparator:this.currentComparator, orderBy:this.currentOrderBy});
            },

            /**
             * The page component is alive as far as the controller is alive.
             * When the page is closed from some reason - we re-init the component (_onPageClose)
             * @private
             */
            _initPageComponent: function() {
                LEManager.logger.debug ("init page component","CategoriesTableController:_initPageComponent");
                this.pageView = new Page({
                    moduleName:LEManager.moduleName,
                    context:LE.context,
                    additionalClassName:  ADDITIONAL_PAGE_CLASS_NAME,
                    header: {
                        title: LE.translator.translate("LEManager.categories.list.title"),
                        description: LE.translator.translate("LEManager.categories.list.description")
                    },
                    hasActionStrip: this.hasEditPrivileges
                });
                this.listenTo(this.pageView, "close", this._onPageClose);
            },

            /**
             * Bind all the relevant handlers to the vent and to the collections
             * @private
             */
            _bindEvents: function() {
                LEManager.logger.debug ("bind events","CategoriesTableController:_bindEvents");

                this.listenTo(this.vent, "categoryTableLayout:actions:new", this.addNewCategoryUi);
                this.listenTo(this.vent, "categoryTableLayout:actions:new:cancel", this.cancelNewCategoryUi);
                this.listenTo(this.vent, "categoryTableLayout:actions:delete", this.areYouSureDelete);
                this.listenTo(this.vent, "categoryTableLayout:buttons:done", this.navigateOut);
                this.listenTo(this.vent, "categoryTableLayout:buttons:close", this.navigateOut);
                this.listenTo(this.vent, "categoryTable:add", this.addNewCategory);
                this.listenTo(this.vent, "categoryTable:change:name", this.changeCategoryName);
                this.listenTo(this.vent, "categoryTable:change:proposed", this.changeCategoryProposed);
                this.listenTo(this.vent, "categoryTable:change:order:movetop", this.changeCategoryOrderMoveTop);
                this.listenTo(this.vent, "categoryTable:change:order:moveup", this.changeCategoryOrderMoveUp);
                this.listenTo(this.vent, "categoryTable:change:order:movedown", this.changeCategoryOrderMoveDown);

                // reset is triggered by the organize function (after sort), and then we need to "handleAfterSort"
                this.listenTo(this.categoriesWithDependenciesCollection, "reset", this.handleOrderActionsAfterSort);

                // fetch:success is triggered by any change in the models (add/update etc) and then we need to handle the add button according to the numbers of categories
                this.listenTo(this.categoriesWithDependenciesCollection, "fetch:success", this._handleAddCategoryButton);
            },

            /**
             * The ACCESS POINT to the flow.
             * This is the method the route controller calls when the categories table should be shown.
             * In this case we first show the loader, persist the merged collection and when it is fetched we show the table
             */
            showCategoryList: function() {
                LEManager.logger.debug ("show category list","CategoriesTableController:showCategoryList");

                this.pageView.showLoader();

                this.listenTo(Backbone.history, "route", this.closePage);

                LEManager.getDataManager().persistCategoriesWithDependencies(true);

                this.categoriesWithDependenciesCollection.onInitialFetched(_.bind(this.showTable, this));
                this._handleCollectionsError();
            },

            /**
             * Listens to error on collections fetch
             * @private
             */
            _handleCollectionsError: function() {
                LEManager.logger.debug ("bind events on collection fetch error","CategoriesTableController:_handleCollectionsError");

                var errorState = this.categoriesCollection.FetchStateEnum.ERROR;
                if (this.categoriesCollection.getFetchState() === errorState || this.categoriesWithDependenciesCollection.getFetchState() === errorState) {
                    this._showNoData();
                }
                else {
                    this.listenTo(this.categoriesWithDependenciesCollection, "fetch:error", this._showNoData);
                }
            },

            /**
             * Responsible for showing the UI of the table.
             * Set the Layout in the Page Components and then show the gridView in the Layout
             * Also, handle the state of the "add category" button and show "welcome message"
             */
            showTable: function() {
                LEManager.logger.debug ("show the layout and table","CategoriesTableController:showTable");

                this._initTableViews();

                this.listenToOnce(this.categoriesLayoutView, "render", _.bind(function(){
                    this.categoriesLayoutView.tableRegion.show(this.categoriesGridView);
                },this));
                this.pageView.setInsideView(this.categoriesLayoutView);

                this._handleAddCategoryButton();

                this.pageView.closeLoader();

                if (this.hasEditPrivileges) {
                    LEManager.notifier.showWarning(LE.translator.translate("LEManager.categories.list.welcome.text"));
                }
            },

            /**
             * Init the GridLayout and the GridView
             * @private
             */
            _initTableViews: function() {
                LEManager.logger.debug ("init the layout and table view","CategoriesTableController:_initTableViews");
                this.categoriesGridView = new CategoriesGridView({
                    vent:this.vent,
                    reqres: this.reqres,
                    collection:this.categoriesWithDependenciesCollection,
                    model: this.categoriesGridModel,
                    comparators: CategoriesComparators,
                    orderComparator: ORDER_COMPARATOR,
                    hasEditPrivileges: this.hasEditPrivileges
                });

                this.categoriesLayoutView = new CategoriesTableLayout({
                    vent:this.vent,
                    collection: this.categoriesWithDependenciesCollection,
                    hasEditPrivileges: this.hasEditPrivileges
                });
            },

            /**
             * Triggered after sort, calculates if the order action buttons should be shown (only if the user sorts by ASC ORDER) and triggers an event to the table
             * @param collection
             * @param options
             */
            handleOrderActionsAfterSort: function(collection, options) {
                if (_.has(options, "comparator")) {
                    var newComparatorFunc = options.comparator;
                    var newComparatorObj = _.find(CategoriesComparators, {"func":newComparatorFunc});
                    if (!_.isUndefined(newComparatorObj)) {
                        this.currentComparator = newComparatorObj.name;
                    }
                }

                if (_.has(options, "orderBy")) {
                    this.currentOrderBy = options.orderBy;
                }

                var showOrderActions = (this.currentComparator === ORDER_COMPARATOR && this.currentOrderBy === ASC_ORDERBY);
                LEManager.logger.debug ("handle the order actions","CategoriesTableController:handleOrderActionsAfterSort", showOrderActions);
                this.vent.trigger("categoriesTable:showOrderActions", showOrderActions);
            },

            /**
             * Triggered by click on any "move-up" button
             * @param itemView
             * @param itemModel
             */
            changeCategoryOrderMoveUp: function(itemView, itemModel) {
                LEManager.logger.info ("move up category","CategoriesTableController:changeCategoryOrderMoveUp", itemModel);

                this._pageBeforeApiCall(API_ORDER);
                this.categoriesCollection.moveUp(itemModel.id, {
                    success: _.bind(this.categoryMoveSuccess,this),
                    error: _.bind(this.categoryMoveError,this)
                });
            },

            /**
             * Triggered by click on any "move-top" button
             * @param itemView
             * @param itemModel
             */
            changeCategoryOrderMoveTop: function(itemView, itemModel) {
                LEManager.logger.info ("move top category","CategoriesTableController:changeCategoryOrderMoveTop", itemModel);

                this._pageBeforeApiCall(API_ORDER);
                this.categoriesCollection.moveTop(itemModel.id, {
                    success: _.bind(this.categoryMoveSuccess,this),
                    error: _.bind(this.categoryMoveError,this)
                });
            },

            /**
             * Triggered by click on any "move-down" button
             * @param itemView
             * @param itemModel
             */
            changeCategoryOrderMoveDown: function(itemView, itemModel) {
                LEManager.logger.info ("move down category","CategoriesTableController:changeCategoryOrderMoveDown", itemModel);

                this._pageBeforeApiCall(API_ORDER);
                this.categoriesCollection.moveDown(itemModel.id, {
                    success: _.bind(this.categoryMoveSuccess,this),
                    error: _.bind(this.categoryMoveError,this)
                });
            },

            /**
             * Triggered when any of the "moves" APIs success.
             * In this case we have a tricky situation that might be buggy but it seems to work.
             * The "fetch:success" of the categoriesCollection triggers a dependency API hit in the data manager and when it comes back the merged triggers "fetch:success".
             * Here we listens to the successful of the merged collection.
             * It's a bit tricky because we assume that we have enough time to listen to the event before it triggers
             * Flow:
             * Change Categories API
             *      success:
             *          Load Dependency API
             *              success: triggers merged collection fetch:success
             *          listenTo merged collection success
             */
            categoryMoveSuccess: function() {
                LEManager.logger.debug ("move category success","CategoriesTableController:categoryMoveSuccess");

                this.listenToOnce(this.categoriesWithDependenciesCollection, "fetch:success", _.bind(function() {
                    this._pageAfterApiCall(API_ORDER);
                },this));
            },

            /**
             * Triggered when any of the "moves" APIs get an error
             * We show an error on the page.
             * The message is not translated because we don't have any specific error on the save for this API.
             * @param model
             * @param resp
             * @param options
             */
            categoryMoveError: function(model, resp, options) {
                LEManager.logger.debug ("move category error","CategoriesTableController:categoryMoveError");

                this._pageAfterApiCall(API_ORDER);

                var errorMsg = "";
                if (resp && _.has(resp, "responseError") && _.has(resp.responseError, "message")) {
                    errorMsg = resp.responseError.message;
                }

                this._showError({api:API_ORDER, errorMsg:errorMsg});
            },

            /**
             * When user ask to delete a category we first show him an "are-you-sure" dialog.
             * Only if the user confirms we delete the category
             */
            areYouSureDelete: function() {
                LEManager.logger.debug ("show delete dialog","CategoriesTableController:areYouSureDelete");

                LEManager.notifier.showConfirm({
                    title: LE.translator.translate("LEManager.categories.list.delete.confirm.title"),
                    content: LE.translator.translate("LEManager.categories.list.delete.confirm.text"),
                    objectAction: {
                        text: LE.translator.translate("LEFramework.global.captions.yes"),
                        callback:_.bind(this.deleteCategory, this)
                    }
                });
            },

            /**
             * Delete the category - triggered if the user confirms the deletion in the "are-you-sure" dialog
             */
            deleteCategory: function() {
                this._pageBeforeApiCall(API_DELETE);

                var selectedModel = this.categoriesWithDependenciesCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {
                    LEManager.logger.info ("delete category","CategoriesTableController:areYouSureDelete", selectedModel.id);

                    this.categoriesCollection.destroyModels([selectedModel.id],{
                        success: _.bind(this._deleteSuccess, this),
                        error: _.bind(this._deleteError, this)
                    });
                }
            },

            /**
             * Triggered when any of the delete success.
             * In this case we have a tricky situation that might be buggy but it seems to work.
             * The "fetch:success" of the categoriesCollection triggers a dependency API hit in the data manager and when it comes back the merged triggers "fetch:success".
             * Here we listens to the successful of the merged collection.
             * It's a bit tricky because we assume that we have enough time to listen to the event before it triggers
             * Flow:
             * Change Categories API
             *      success:
             *          Load Dependency API
             *              success: triggers merged collection fetch:success
             *          listenTo merged collection success
             */
            _deleteSuccess: function(collection, response, options) {
                LEManager.logger.debug ("delete category success","CategoriesTableController:_deleteSuccess");
                this.categoriesWithDependenciesCollection.clearSelection();
                this.listenToOnce(this.categoriesWithDependenciesCollection, "fetch:success", _.bind(function() {
                    var successMsg = LE.translator.translate("LEManager.categories.list.delete.success.text");
                    LEManager.notifier.showSuccess({content : successMsg, timeToShow : 6000});
                    this._pageAfterApiCall(API_DELETE);
                }, this));
            },

            /**
             * Triggered when the delete API get an error
             * We show an error on the page.
             * The message is not translated by default - only if we know about specific error code ("dependency conflict")
             * @param model
             * @param resp
             * @param options
             */
            _deleteError: function(model, resp, options) {
                LEManager.logger.debug ("delete category error","CategoriesTableController:_deleteError");

                this._pageAfterApiCall(API_DELETE);

                var errorMsg = "";
                if (resp && _.has(resp, "responseError") && _.has(resp.responseError, "message")) {
                    errorMsg = resp.responseError.message;
                }

                if (resp && _.has(resp,"responseError") && _.has(resp.responseError,"internalCode")){
                    if (resp.responseError.internalCode === ErrorCodes.dependencyConflict) {
                        errorMsg = LE.translator.translate("LEManager.categories.list.delete.error.dependencyConflict.text");
                    }
                }

                this._showError({api:API_DELETE, errorMsg:errorMsg});
            },

            /**
             * Triggered when user clicks the "Add category" button and triggers an event to the table to add the "new category view" with new model
             */
            addNewCategoryUi: function() {
                LEManager.logger.debug ("add new category UI in the table","CategoriesTableController:addNewCategoryUi");

                var newOrder = this.categoriesWithDependenciesCollection.size() + 1;
                var newCategoryModel = new CategoryModel({order:newOrder});
                this.vent.trigger("categoriesTable:addNewCategoryView", newCategoryModel);
            },
            cancelNewCategoryUi: function(newCategoryModel) {
                LEManager.logger.debug ("remove the new category UI in the table","CategoriesTableController:cancelNewCategoryUi");

                this.vent.trigger("categoriesTable:removeCategoryView", newCategoryModel);
            },

            /**
             * Saves the new category.
             * Because this is a new model (not connected to any of the collections) we saves this model
             * @param itemView
             * @param itemModel
             * @param newName
             */
            addNewCategory: function(itemView, itemModel, newName) {
                LEManager.logger.debug ("add new category","CategoriesTableController:addNewCategory", itemModel);

                itemModel.set(itemModel.KEYS.NAME, newName);
                itemModel.unset(itemModel.KEYS.ORDER);

                this.dataToSave = {
                    isNew: true,
                    previousData: {}, // previous data is empty because it's new model
                    newName: newName,
                    itemView: itemView,
                    itemModel: itemModel
                };
                this.saveCategory();
            },

            /**
             * Updates the name of the category.
             * The update must be on the simple category model in the Categories Collection (in addition to the merged model from the table)
             * We take the name from the merged model and set it on the category model.
             * We save the category simple model.
             * Also, We send as data the previous name in order to revert the name on the model if we get an error.
             * @param itemView
             * @param itemModel
             * @param newName
             */
            changeCategoryName: function(itemView, itemModel, newName) {
                LEManager.logger.debug ("change category name","CategoriesTableController:changeCategoryName", itemModel);

                var originCategoryModel = this.categoriesCollection.get(itemModel.id);
                var oldName = originCategoryModel.get(itemModel.KEYS.NAME);
                originCategoryModel.set(originCategoryModel.KEYS.NAME, newName);
                itemModel.set(originCategoryModel.KEYS.NAME, newName);

                this.dataToSave = {
                    previousData: {
                        "name": oldName
                    },
                    newName: newName,
                    itemView: itemView,
                    itemModel: originCategoryModel
                };
                this.saveCategory();
            },

            /**
             * Updates the proposed attribute of the category.
             * The update must be on the simple category model in the Categories Collection (in addition to the merged model from the table)
             * We take the proposed value from the merged model and set it on the category model.
             * We save the category simple model.
             * Also, We send as data the previous proposed value in order to revert the value if we get an error.
             * @param itemView
             * @param itemModel
             * @param newProposed
             */
            changeCategoryProposed: function(itemView, itemModel, newProposed) {
                LEManager.logger.debug ("change category proposed","CategoriesTableController:changeCategoryProposed", itemModel);

                var originCategoryModel = this.categoriesCollection.get(itemModel.id);
                var oldProposed = originCategoryModel.get(itemModel.KEYS.PROPOSED);
                originCategoryModel.set(originCategoryModel.KEYS.PROPOSED, newProposed);
                itemModel.set(originCategoryModel.KEYS.PROPOSED, newProposed);

                this.dataToSave = {
                    previousData: {
                        "proposed": oldProposed
                    },
                    newProposed: newProposed,
                    itemView: itemView,
                    itemModel: originCategoryModel
                };
                this.saveCategory();
            },

            /**
             * Saves the category.
             * This is a simple save, only for name and proposed attributes, once at a time.
             * For Order attribute or DELETE we have different methods that handle that
             */
            saveCategory: function() {
                LEManager.logger.info ("save category","CategoriesTableController:saveCategory", this.dataToSave);

                this._pageBeforeApiCall(API_SAVE);
                this.dataToSave.itemModel.save(null, {
                    success: _.bind(this._saveSuccess, this),
                    error: _.bind(this._saveError, this)
                });
            },

            /**
             * Triggers when the Save success.
             * We update the Categories Collection and set the new revision
             * If we just save a new model we should wait until the merged collection to be updated before we call the "AfterApiCall" (that removes the loader etc...)
             * @param model
             * @param resp
             * @param options
             * @private
             */
            _saveSuccess: function(model, resp, options) {
                LEManager.logger.debug ("save category success","CategoriesTableController:_saveSuccess", model);

                options = options || {};
                options.merge = true;
                options.silent = false;
                var mergedModel = this.categoriesCollection.add(model.toJSON(), options);
                if (mergedModel) {
                    mergedModel.setRevision(model.getRevision(true));
                }

                if (this.dataToSave.isNew) {
                    this.listenToOnce(this.categoriesWithDependenciesCollection, "fetch:success", function() {
                        this._pageAfterApiCall(API_SAVE);
                    });
                }
                else {
                    this._pageAfterApiCall(API_SAVE);
                }
            },

            /**
             * Before saving a model we bind a listener to its "validated:invalid" event to catch it if it has any client-side validation error.
             * In this case, we need to propagate it to the relevant view so it will handle the error in the UI
             * @private
             */
            _saveOnInvalid: function() {
                LEManager.logger.debug ("save category failed because client side validation","CategoriesTableController:_saveOnInvalid");

                if (_.isFunction(this.dataToSave.itemView.onSaveInvalid)) {
                    this.dataToSave.itemView.onSaveInvalid.apply(this.dataToSave.itemView, arguments);
                }
                this._pageAfterApiCall(API_SAVE);
            },

            /**
             * Error on save.
             * We find the error and handle it according to the type of the error.
             * @param model
             * @param resp
             * @param options
             * @private
             */
            _saveError: function(model, resp, options) {
                LEManager.logger.debug ("save category failed because server side validation","CategoriesTableController:_saveError");

                this._pageAfterApiCall(API_SAVE);

                var errorMsg = "";
                if (resp && _.has(resp, "responseError") && _.has(resp.responseError, "message")) {
                    errorMsg = resp.responseError.message;
                }
                if (resp && _.has(resp,"responseError") && _.has(resp.responseError,"internalCode")){
                    if (resp.responseError.internalCode === ErrorCodes.uniquenessViolation) {
                        errorMsg = LE.translator.translate("LEManager.categories.errors.categoryName.duplicate");
                        this._handleErrorDuplicateName(model, resp, options, errorMsg);
                    }
                    else if(resp.responseError.internalCode === ErrorCodes.maxEntityLimitViolation) {
                        errorMsg = LE.translator.translate("LEManager.categories.errors.categories.maximum");
                        this._handleErrorMaxItems(model, resp, options, errorMsg);
                    }
                    else {
                        // If the save is failed from some reason we want to set the previous data on the model (we have some...)
                        if (!_.isEmpty(this.dataToSave.previousData)) {
                            LEManager.logger.debug ("revert to previous data","CategoriesTableController:_saveError", this.dataToSave.previousData);
                            this.dataToSave.itemView.model.set(this.dataToSave.previousData);
                            var categoryModel = this.categoriesCollection.get(model.id);
                            if (!_.isEmpty(categoryModel)) {
                                categoryModel.set(this.dataToSave.previousData);
                            }
                        }
                    }
                }

                this._showError({api:API_SAVE, errorMsg:errorMsg, isBlock:false});
            },

            /**
             * When the user is trying to give a duplicated name we need to set the model with the previous value
             * And set the error on the UI
             * @param model
             * @param resp
             * @param options
             * @param errorMsg
             * @private
             */
            _handleErrorDuplicateName: function(model, resp, options, errorMsg) {
                LEManager.logger.debug ("handle duplicate name","CategoriesTableController:_handleErrorDuplicateName");

                var mergedModel = this.categoriesCollection.get(model.id);
                if (mergedModel) {
                    mergedModel.set(this.dataToSave.previousData, {silent: true}); // this is done because we only want the ui to display the incorrect value and in the model to save the previous value again
                    this.dataToSave.itemView.model.set(this.dataToSave.previousData, {silent: true});
                }
                this.dataToSave.itemView.setError(model.KEYS.NAME, true, errorMsg);
            },

            /**
             * When the user exceeds the maximum categories, we removes the "new category" view
             * @param model
             * @param resp
             * @param options
             * @private
             */
            _handleErrorMaxItems: function(model, resp, options) {
                LEManager.logger.debug ("handle max entities","CategoriesTableController:_handleErrorMaxItems");

                this.vent.trigger("categoriesTable:removeCategoryView", this.dataToSave.itemModel);
            },

            /**
             * Before any of the API calls we show the loader, disable the navigation
             * And if the API is a "SAVE API" (model.save) we bind a listener to the "validated:invalid" of the model to catch client-side validation from backbone.validation
             * This is done because the model we save is not the one that connected to the view. The model is the simple one from Category Collection
             * @param api
             * @private
             */
            _pageBeforeApiCall: function(api) {
                LEManager.logger.debug ("prepare the ui for any API call","CategoriesTableController:_pageBeforeApiCall", api);

                this.vent.trigger("categories:enableNavigation", false);
                this.pageView.showLoader();
                if (api === API_SAVE) {
                    this.listenTo(this.dataToSave.itemModel, "validated:invalid", this._saveOnInvalid);
                }
            },

            /**
             * After any of the API calls (no matter if it is success/invalid/error) we remove the loader, enable the navigation and handle the state of the "Add category" button (according to the number of the categories after the API hit)
             * Also, if the API is "SAVE API" (model.save) we unbind the listener to "validated:invalid" we binded before the API call.
             * @param api
             * @private
             */
            _pageAfterApiCall: function(api) {
                LEManager.logger.debug ("enable the ui after any API call","CategoriesTableController:_pageAfterApiCall", api);

                this.vent.trigger("categories:enableNavigation", true);
                this.pageView.closeLoader();
                this._handleAddCategoryButton();
                if (api === API_SAVE) {
                    this.stopListening(this.dataToSave.itemModel, "validated:invalid");
                }
            },

            /**
             * Generic method to show an error on the page.
             * Must get in the options object the errorMsg (can be empty string), and the api (in order to show the correct labels...)
             * Optional attribute is the "isBlock". TRUE - shows the error as dialog. FALSE - shows the error as notifier at the top of the page
             * @param options
             * @private
             */
            _showError: function(options) {
                LEManager.logger.debug ("show error","CategoriesTableController:_showError", options);

                var errorMsg = options.errorMsg;
                var api = options.api;
                var isBlock = _.has(options, "isBlock") ? options.isBlock : true;

                if (!_.isEmpty(errorMsg)) {
                    if (isBlock) {
                        LEManager.notifier.showError({
                            title: LE.translator.translate("LEManager.categories.list."+api+".error.title"),
                            content:options.errorMsg,
                            "objectAction":{
                                text: LE.translator.translate("LEFramework.global.captions.ok"),
                                callback: function(){}
                            },
                            removeAditionalButton: true
                        });
                    }
                    else {
                        LEManager.notifier.showError({content : errorMsg, timeToShow : 6000});
                    }
                }
            },

            _showNoData: function() {
                LEManager.logger.info ("show no data","CategoriesTableController:_bindCollectionsError");
                this.pageView.setInsideView(new NoData({el:'.manager-region'}));
            },

            /**
             * Triggers an event to the layout if the add category button should be enabled or disabled according to the API on the data controller
             * @private
             */
            _handleAddCategoryButton: function() {
                this.vent.trigger("categoryTableLayout:addCategoryEnabled", LEManager.getDataManager().isAddCategoryEnabled());
            },

            /**
             * When you click "X" or "Done" you get the previous page you came from
             */
            navigateOut: function() {
                LEManager.router.navigateBack();
            },

            /**
             * When the view loads we are listening to any route.
             * This is done because we want to close the page when the user goes out from this page.
             * When the user navigate from this page we want at stop the persistence of the merged collection so we call the "close" on the page component
             * We must check that the user doesn't navigate to LEManager. If he does, the Route Controller of LEManager will close the Page component so we must ignore it.
             * @param options
             * @param handler
             */
            closePage: function(options, handler) {
                if (handler.indexOf("LEManager") !== 0) { // if the route is not to LEManager we need to close the pageView
                    LEManager.logger.info ("close the page component","CategoriesTableController:closePage", handler);

                    this.pageView.close();
                }
            },

            /**
             * When the page is closed we stop the persistence of the categories with dependencies collection ("the merged collection")
             * Stop listening to the current page component (it's already closed)
             * Stop listening to the routing of the user (the user already leaves this view - who cares where he's going.. ;-)
             * and re-init a new Page component - we must have a live Page component always so we can show a loader when we need
             * @private
             */
            _onPageClose: function() {
                LEManager.getDataManager().persistCategoriesWithDependencies(false);
                this.stopListening(this.categoriesWithDependenciesCollection, "fetch:error");
                this.stopListening(this.pageView);
                this.stopListening(Backbone.history);
                this._initPageComponent();
            },

            /**
             * Our main view is....... the Page component
             * @returns {Page|*}
             */
            getMainView: function() {
                return this.pageView;
            }

        });
    });
    return  CategoriesTableController;
});

